<template>
  <svg
    class="text-gray-300 "
    width="64"
    height="64"
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g transform="translate(32,32)">
      <g>
        <rect
          v-for="(angle, index) in 12"
          :key="index"
          x="-3"
          y="-28"
          width="6"
          height="12"
          rx="3"
          fill="currentColor"
          :transform="'rotate(' + (index * 30) + ')'"
          :class="getBarClass(index)"
        />
        <!-- <rect
          v-for="(angle, index) in 12"
          :key="index"
          x="-3"
          y="-28"
          width="6"
          height="12"
          rx="3"
          fill="currentColor"
          :transform="'rotate(' + (index * 30) + ')'"
          :class="'transition-all duration-300 ' + getBarColor(index)"
          :style="{ opacity: getBarOpacity(index) }"
        /> -->
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'ProgressSpinner',

  props: {
    progress: {
      type: Number,
      required: true
    }
  },

  computed: {

  },

  methods: {
    // Este para que pinte en tres colores colores completos
    // getBarClass(index) {
    //   const activeBars = Math.round((this.progress / 100) * 12)
    //   if (index < activeBars) {
    //     if (this.progress < 33) return 'text-red-light'
    //     if (this.progress < 66) return 'text-yellow-light'
    //     return 'text-green-light'
    //   }
    //   return 'text-gray-light'
    // }

    // un solo color con apacidad si no completa
    getBarClass(index) {
      const totalBars = 12;
      const barValue = 100 / totalBars;
      const currentValue = index * barValue;
      const nextValue = (index + 1) * barValue;

      if (this.progress >= nextValue) {
        return 'text-green-light';
      }

      if (this.progress > currentValue) {
        return 'text-green-light opacity-50'; // Barra parcial
      }

      return 'text-gray-light';
    },


    getBarColor(index) {
      if (this.progress < 33) return 'text-red-light';
      if (this.progress < 66) return 'text-yellow-light';
      return 'text-green-light';
    },

    getBarOpacity(index) {
      const progressPerBar = 100 / 12;
      const start = index * progressPerBar;
      const end = (index + 1) * progressPerBar;

      if (this.progress >= end) return 1;
      if (this.progress <= start) return 0.2;

      // Barra parcial
      return ((this.progress - start) / progressPerBar).toFixed(2);
    }
  }
}
</script>